import { Fit } from "@seneca/image-service-client";

import { getDimensionFromCSSVar } from "seneca-common/utils/functions";

import type { ModuleDeviceRequirements } from "features/module/types";

import styles from "./components/common.module.scss";

export const assetParameters = {
  default: {
    width: getDimensionFromCSSVar(styles.flashcardfrontimgwidth),
    height: getDimensionFromCSSVar(styles.flashcardfrontimgheight),
    fit: Fit.COVER
  }
};

export const DEVICE_REQUIREMENTS: ModuleDeviceRequirements = {
  minModuleWidth: 300,
  desktopOnly: false
};
